export class LogsBulkInsertResponse {
	hasError: boolean;
	createdItems: number[];
}
